import React from 'react'
import {useEffect} from '@hooks/useEffect'
import FormatNumber from '@i18n/formatNumber/Component'
import roundMoney from '@i18n/roundMoney'
import {useRefetchQueries} from '@packages/apollo-hooks'

import ActionButtons from './ActionButtons'
import Orders from './Orders'

import styles from './styles.module.css'

export default function TableOrders(props) {
  const {tableTotal, ordersGroupedByUser, preferences, setOpenResume} = props
  const refreshQuery = useRefetchQueries()
  const tip = roundMoney(tableTotal * 0.1)
  const totalOrder = roundMoney(tableTotal + tip)

  useEffect(() => {
    refreshQuery('getUserOrderGroup')
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.orderContainer}>
        {ordersGroupedByUser.map((item, index) => (
          <Orders key={index} {...item} />
        ))}
      </div>

      <div className={styles.pendingOrder}>
        <h4>Pago pendiente de Mesa {preferences.tableName}</h4>
        <h4>
          <FormatNumber value={tableTotal} />
        </h4>
      </div>

      <div className={styles.suggestedTip}>
        <p>Propina sugerida (10%) </p>
        <p>
          <FormatNumber value={tip} />
        </p>
      </div>

      <div className={styles.pendingOrder}>
        <h4>Total a pagar con propina </h4>
        <h4>
          <FormatNumber value={totalOrder} />
        </h4>
      </div>

      <ActionButtons preferences={preferences} setOpenResume={setOpenResume} />
    </div>
  )
}
